


























































import {
  BaseButton,
  BaseLink,
  BaseIcon,
  TypeDisplay,
  TypeBody,
  TypeOverline,
} from '@bambeehr/pollen';
import { defineComponent, PropType, useRouter } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ContentCard',
  components: {
    TypeDisplay,
    TypeOverline,
    TypeBody,
    BaseButton,
    BaseIcon,
    BaseLink,
  },
  props: {
    decorator: {
      type: String,
    },
    title: {
      type: String,
    },
    body: {
      type: String,
    },
    showLink: {
      type: Boolean,
    },
    buttonText: {
      type: String,
    },
    link: {
      type: String,
    },
    showCheckItems: {
      type: Boolean,
    },
    checkItems: {
      type: Array as PropType<{ text?: string }[]>,
    },
    linkStyle: {
      type: String,
    },
  },
  setup(props) {
    const router = useRouter();

    const goToLink = () => {
      if (props.link) {
        router.push(props.link);
      }
    };

    return {
      goToLink,
    };
  },
});
